import type {RouteRecordRaw} from "vue-router";

import {route as listRoute, routeName as listRouteName} from './list';
import {route as docRoute} from './doc';
import IconDraftStatus from "@/shared/ui/icons/document/DocumentDraft.vue";

export const routeName = 'Draft';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'draft',
    redirect: {
        name: listRouteName,
    },
    children: [
        docRoute,
        listRoute,
    ],
    meta: {
        title: 'status_draft',
        icon: IconDraftStatus,
        isNavTab: true,
    }
};
